import { render, staticRenderFns } from "./AnnualReportList.vue?vue&type=template&id=c192cffc&scoped=true&"
import script from "./AnnualReportList.vue?vue&type=script&lang=ts&"
export * from "./AnnualReportList.vue?vue&type=script&lang=ts&"
import style0 from "./AnnualReportList.vue?vue&type=style&index=0&id=c192cffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c192cffc",
  null
  
)

export default component.exports